import React from "react";
import { Icon } from "antd";
import { css } from "glamor";

import StartProcessHook from "../../../api/process";

const style = {
    editIcon: css({
        float: "right",
        width: "14px",
        height: "14px",
        opacity: 0.65,
        color: "#1b75bc",
        marginRight: "60px",
        cursor: "pointer",
    }),
};

const EditIcon = <Icon type="edit" {...style.editIcon} />;

const RelatedEntitiesActionButtons = ({ mainEntity, relatedEntity }) => {
    return (
        <StartProcessHook
            hookType={8}
            params={{
                main_entity_ulid: mainEntity.key.ulid,
                related_entity_ulid: relatedEntity.key.ulid,
            }}
            component={EditIcon}
        />
    );
};

export default RelatedEntitiesActionButtons;
